const downloadDocument = (document: RelatedDocument) => {
  // TODO : télécharger à partir d'une url
  return undefined
}

const downloadAll = (documents: Documents) => {
  const files = []

  if (documents.edl.entry) {
    files.push(documents.edl.entry)
  }
  if (documents.edl.exit) {
    files.push(documents.edl.exit)
  }
  if (documents.checklist) {
    files.push(documents.checklist)
  }

  files.forEach(downloadDocument)
}

export { downloadDocument, downloadAll }
